exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button-group[data-v-dc2144b8]{width:100%;display:flex;justify-content:flex-end}.button-group button[data-v-dc2144b8]:last-of-type{margin-left:1rem}span[data-v-dc2144b8]{font-weight:700}", ""]);

// exports
